import { Discount, Price } from 'shared-types';

export const getPriceForMinimumGuests = (price: Price, minimumGuests: number | null): Price => {
  if (price.amount && minimumGuests) {
    return {
      ...price,
      amount: price.amount * minimumGuests,
    };
  }
  return price;
};

export const getDiscountForMinimumGuests = (
  discount: Discount | undefined,
  minimumGuests: number | null
): Discount | undefined => {
  if (discount?.discountedPrice?.amount && minimumGuests) {
    return {
      ...discount,
      discountedPrice: {
        ...discount.discountedPrice,
        amount: discount.discountedPrice.amount * minimumGuests,
      },
      standardPrice: discount.standardPrice && {
        ...discount.standardPrice,
        amount: discount.standardPrice.amount * minimumGuests,
      },
    };
  }
  return discount;
};
